<template>
    <div>
        <v-layout>
            <v-flex xs12 sm6 offset-sm3 style="padding: 10px">
                <card class="z-depth-1">
                    <v-card-title primary-title class="layout justify-center">
                        <div class="headline">Kontaktieren Sie uns</div>
                    </v-card-title>
                    <v-card-text class="layout justify-center">
                        <v-list class="transparent" three-line>
                            <v-list-tile>
                                <v-list-tile-action>
                                <v-icon class="blue--text text--lighten-2">phone</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title>+49 4101 606880</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon class="blue--text text--lighten-2">place</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>optiWatt GmbH</v-list-tile-title>
                                    <v-list-tile-title>Heinrich-Specht-Weg 26</v-list-tile-title>
                                    <v-list-tile-title>D-25421 Pinneberg, Schleswig-Holstein</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-action>
                                <v-icon class="blue--text text--lighten-2">email</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title>thuemler@optiwatt.de</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card-text>
                </card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import card from '@/components/Card';
    import cardHeader from '@/components/CardHeader';
    import cardBody from '@/components/CardBody';
    export default {
        components:{
            'Card': card,
            'CardHeader': cardHeader,
            'CardBody': cardBody,
        }
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/subpages/contact.vue